/*
* Chartkick.js
* Create beautiful JavaScript charts with minimal code
* https://github.com/ankane/chartkick.js
* v2.0.1
* MIT License
*/
//
//
//
// TODO(SI): this is basically our refactor of Chartkick, to integrate it into our module system.
// It will only work with Highcharts at the moment.
// It assumes that highcharts_global_hack.js was already imported in global.js and injected the Highcharts object
// into window.
//
//
// We would need to inject the other chart libraries manually if we want them.
//
//
//

import $ from "jquery";
import adjustPieChartCenterText from "./util/adjust_pie_chart_title";
import numeral from "numeral";

const Highcharts = window.Highcharts;

const ChartkickOptions = null;
const jQuery = null;
const Zepto = null;
const google = null;

const attachEvent = window.attachEvent;
const addEventListener = window.addEventListener;

const Chart = null;

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const config = ChartkickOptions || {};
let Chartkick, ISO8601_PATTERN, DECIMAL_SEPARATOR, adapters = [];
const DATE_PATTERN = /^(\d\d\d\d)(\-)?(\d\d)(\-)?(\d\d)$/i;
let GoogleChartsAdapter, HighchartsAdapter, ChartjsAdapter;

// https://github.com/Do/iso8601.js
ISO8601_PATTERN = /(\d\d\d\d)(\-)?(\d\d)(\-)?(\d\d)(T)?(\d\d)(:)?(\d\d)?(:)?(\d\d)?([\.,]\d+)?($|Z|([\+\-])(\d\d)(:)?(\d\d)?)/i;
DECIMAL_SEPARATOR = String(1.5).charAt(1);

function parseISO8601(input) {
  let day, hour, matches, milliseconds, minutes, month, offset, result, seconds, type, year;
  type = Object.prototype.toString.call(input);
  if (type === "[object Date]") {
    return input;
  }
  if (type !== "[object String]") {
    return;
  }
  matches = input.match(ISO8601_PATTERN);
  if (matches) {
    year = parseInt(matches[1], 10);
    month = parseInt(matches[3], 10) - 1;
    day = parseInt(matches[5], 10);
    hour = parseInt(matches[7], 10);
    minutes = matches[9] ? parseInt(matches[9], 10) : 0;
    seconds = matches[11] ? parseInt(matches[11], 10) : 0;
    milliseconds = matches[12] ? parseFloat(DECIMAL_SEPARATOR + matches[12].slice(1)) * 1000 : 0;
    result = Date.UTC(year, month, day, hour, minutes, seconds, milliseconds);
    if (matches[13] && matches[14]) {
      offset = matches[15] * 60;
      if (matches[17]) {
        offset += parseInt(matches[17], 10);
      }
      offset *= matches[14] === "-" ? -1 : 1;
      result -= offset * 60 * 1000;
    }
    return new Date(result);
  }
}
// end iso8601.js
//
// helpers

function isArray(variable) {
  return Object.prototype.toString.call(variable) === "[object Array]";
}

function isFunction(variable) {
  return variable instanceof Function;
}

function isPlainObject(variable) {
  return !isFunction(variable) && variable instanceof Object;
}

// type conversions

function toStr(n) {
  return "" + n;
}

function toFloat(n) {
  return parseFloat(n);
}

function toDate(n) {
  let matches, year, month, day;
  if (typeof n !== "object") {
    if (typeof n === "number") {
      n = new Date(n * 1000); // ms
    } else if ((matches = n.match(DATE_PATTERN))) {
      year = parseInt(matches[1], 10);
      month = parseInt(matches[3], 10) - 1;
      day = parseInt(matches[5], 10);
      return new Date(year, month, day);
    } else { // str
      // try our best to get the str into iso8601
      // TODO be smarter about this
      const str = n.replace(/ /, "T").replace(" ", "").replace("UTC", "Z");
      n = parseISO8601(str) || new Date(n);
    }
  }
  return n;
}

function toArr(n) {
  if (!isArray(n)) {
    let arr = [], i;
    for (i in n) {
      if (n.hasOwnProperty(i)) {
        arr.push([i, n[i]]);
      }
    }
    n = arr;
  }
  return n;
}

function isMinute(d) {
  return d.getMilliseconds() === 0 && d.getSeconds() === 0;
}

function isHour(d) {
  return isMinute(d) && d.getMinutes() === 0;
}

function isDay(d) {
  return isHour(d) && d.getHours() === 0;
}

function isWeek(d, dayOfWeek) {
  return isDay(d) && d.getDay() === dayOfWeek;
}

function isMonth(d) {
  return isDay(d) && d.getDate() === 1;
}

function isYear(d) {
  return isMonth(d) && d.getMonth() === 0;
}

function isDate(obj) {
  return !isNaN(toDate(obj)) && toStr(obj).length >= 6;
}

function allZeros(data) {
  let i, j, d;
  for (i = 0; i < data.length; i++) {
    d = data[i].data;
    for (j = 0; j < d.length; j++) {
      if (d[j][1] != 0) {
        return false;
      }
    }
  }
  return true;
}

function detectDiscrete(series) {
  let i, j, data;
  for (i = 0; i < series.length; i++) {
    data = toArr(series[i].data);
    for (j = 0; j < data.length; j++) {
      if (!isDate(data[j][0])) {
        return true;
      }
    }
  }
  return false;
}

function recursiveIterateNestedObject(object, acc, parent) {
  let index = 0;
  let parentId = "id";
  if (parent) {
    parentId = parent.id;
  }

  for (const property in object) {
    if (object.hasOwnProperty(property)) {
      const id = parentId + "_" + index;
      const name = property;

      const point = {
        id: id,
        name: name,
        value: 0
      };
      // Root points in the series do not have a parent property.
      if (parent) {
        point.parent = parentId;
      }
      acc.push(point);

      if (typeof object[property] === "object") {
        recursiveIterateNestedObject(object[property], acc, point);
        if (parent) {
          parent.value += point.value;
        }
      } else {
        const value = Math.round(+object[property]);
        if (parent) {
          parent.value += value;
        }
        point.value = value;
      }
    }

    index += 1;
  }
}

// https://github.com/madrobby/zepto/blob/master/src/zepto.js
function extend(target, source) {
  let key;
  for (key in source) {
    if (isPlainObject(source[key]) || isArray(source[key])) {
      if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
        target[key] = {};
      }
      if (isArray(source[key]) && !isArray(target[key])) {
        target[key] = [];
      }
      extend(target[key], source[key]);
    } else if (source[key] !== undefined) {
      target[key] = source[key];
    }
  }
}

function merge(obj1, obj2) {
  const target = {};
  extend(target, obj1);
  extend(target, obj2);
  return target;
}

function negativeValues(series) {
  let i, j, data;
  for (i = 0; i < series.length; i++) {
    data = series[i].data;
    for (j = 0; j < data.length; j++) {
      if (data[j][1] < 0) {
        return true;
      }
    }
  }
  return false;
}

function jsOptionsFunc(defaultOptions, hideLegend, setMin, setMax, setStacked, setXtitle, setYtitle) {
  return function (series, opts, chartOptions) {
    let options = merge({}, defaultOptions);
    options = merge(options, chartOptions || {});

    // hide legend
    // this is *not* an external option!
    if (opts.hideLegend) {
      hideLegend(options);
    }

    // min
    if ("min" in opts) {
      setMin(options, opts.min);
    } else if (!negativeValues(series)) {
      setMin(options, 0);
    }

    // max
    if (opts.max) {
      setMax(options, opts.max);
    }

    if ("stacked" in opts) {
      setStacked(options, opts.stacked);
    }

    if (opts.colors) {
      options.colors = opts.colors;
    }

    if (opts.xtitle) {
      setXtitle(options, opts.xtitle);
    }

    if (opts.ytitle) {
      setYtitle(options, opts.ytitle);
    }

    // merge library last
    options = merge(options, opts.library || {});

    return options;
  };
}

function setText(element, text) {
  if (document.body.innerText) {
    element.innerText = text;
  } else {
    element.textContent = text;
  }
}

function chartError(element, message) {
  setText(element, "Error Loading Chart: " + message);
  element.style.color = "#ff0000";
}

function getJSON(element, url, success) {
  const helperLib = jQuery || Zepto || $;
  helperLib.ajax({
    dataType: "json",
    url: url,
    success: success,
    error: function (jqXHR, textStatus, errorThrown) {
      const message = (typeof errorThrown === "string") ? errorThrown : errorThrown.message;
      chartError(element, message);
    }
  });
}

function errorCatcher(chart, callback) {
  try {
    callback(chart);
  } catch (err) {
    chartError(chart.element, err.message);
    throw err;
  }
}

function fetchDataSource(chart, callback) {
  if (typeof chart.dataSource === "string") {
    getJSON(chart.element, chart.dataSource, function (data) {
      chart.data = data;
      errorCatcher(chart, callback);
    });
  } else {
    chart.data = chart.dataSource;
    errorCatcher(chart, callback);
  }
}

function sortByTime(a, b) {
  return a[0].getTime() - b[0].getTime();
}

function sortByNumber(a, b) {
  return a - b;
}

let axisLabelFontSize;
if(isMobile) {
  axisLabelFontSize = "10px";
} else {
  axisLabelFontSize = "12px";
}

function loadAdapters() {
  if (!HighchartsAdapter && "Highcharts" in window) {
    HighchartsAdapter = new function () {
      this.name = "highcharts";

      const defaultOptions = {
        chart: {
          events: {
            load: function () {
              this.resetButtonHide();
            }
          }
        },
        xAxis: {
          title: {
            text: null
          },
          labels: {
            style: {
              fontSize: axisLabelFontSize
            }
          }
        },
        yAxis: {
          title: {
            text: null
          },
          labels: {
            style: {
              fontSize: axisLabelFontSize
            }
          }
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        legend: {
          borderWidth: 0,
          y: 35,
          // Show the reset button once anything has been filtered out of the chart, and
          // hide it again when everything is back. Bound to `itemClick` rather than the
          // legacy `legendItemClick` so that a chart whose own options replace this
          // handler still replaces it — the two live at the same path.
          events: {
            itemClick: function () {
              const chart = this.chart;
              setTimeout(function () {
                const unfiltered = chart.options.series.every(function (point) {
                  return point.visible != false;
                });
                if (unfiltered) {
                  chart.resetButtonHide();
                } else {
                  chart.resetButtonShow();
                }
              }, 1);
            }
          }
        },
        tooltip: {
          style: {
            fontSize: "12px"
          },
          followTouchMove: true
        },
        plotOptions: {
          areaspline: {},
          series: {
            marker: {}
          }
        },
        navigation: {
          buttonOptions: {
            theme: {
              style: {
                color: "#ffffff",
                fontSize: "14.5px",
                textDecoration: "none"
              }
            }
          }
        },
        lang: {
          resetTitle: "Show all categories"
        },
        exporting: {
          buttons: {
            customButton: {
              text: "Reset categories",
              _titleKey: "resetTitle",
              onclick: function (e) {
                const buttonGroup = e && e.target && e.target.closest && e.target.closest("g");
                if (buttonGroup && buttonGroup.style.opacity > 0) {
                  for (let i = 0; i < this.series.length; i++) {
                    !this.series[i].visible ? this.series[i].setVisible() : null;
                    buttonGroup.style.opacity = 0;
                  }
                }
              },
              y: -10,
              theme: {
                fill: "#666666",
                r: 0,
                verticalAlign: "middle",
                padding: 9,
                stroke: "#4f4f4f",
                states: {
                  hover: {
                    fill: "#4f4f4f",
                    stroke: "#4f4f4f"
                  }
                }
              },
              data: {
                iconTitle: "Show all categories"
              }
            }
          }
        }
      };

      const hideLegend = function (options) {
        options.legend.enabled = false;
      };

      const setMin = function (options, min) {
        options.yAxis.min = min;
      };

      const setMax = function (options, max) {
        options.yAxis.max = max;
      };

      const setStacked = function (options, stacked) {
        options.plotOptions.series.stacking = stacked ? "normal" : null;
      };

      const setXtitle = function (options, title) {
        options.xAxis.title.text = title;
      };

      const setYtitle = function (options, title) {
        options.yAxis.title.text = title;
      };

      const jsOptions = jsOptionsFunc(defaultOptions, hideLegend, setMin, setMax, setStacked, setXtitle, setYtitle);

      this.renderLineChart = function (chart, chartType) {
        chartType = chartType || chart.options.chartType || "spline";
        let chartOptions = {};
        if (chartType === "areaspline") {
          chartOptions = {
            plotOptions: {
              areaspline: {
                stacking: "normal"
              },
              series: {
                marker: {
                  enabled: false
                }
              }
            }
          };
        } else {
          chartOptions = {
            plotOptions: {
              series: {
                marker: {
                  enabled: false
                }
              }
            }
          };
        }

        const options = jsOptions(chart.data, chart.options, chartOptions);
        let data, i, j;
        options.xAxis.type = chart.options.discrete ? "category" : "datetime";
        options.chart.type = chartType;
        options.chart.renderTo = chart.element.id;

        const series = chart.data;
        for (i = 0; i < series.length; i++) {
          data = series[i].data;
          if (!chart.options.discrete) {
            for (j = 0; j < data.length; j++) {
              data[j][0] = data[j][0].getTime();
            }
          }
          if (chartOptions.plotOptions.series.marker.enabled !== false) {
            series[i].marker = {symbol: "circle"};
          }
        }
        options.series = series;
        new Highcharts.Chart(options);
      };

      this.renderScatterChart = function (chart) {
        const chartOptions = {};
        const options = jsOptions(chart.data, chart.options, chartOptions);
        options.chart.type = "scatter";
        options.chart.renderTo = chart.element.id;
        options.series = chart.data;
        options.plotOptions.series.stickyTracking = false;
        new Highcharts.Chart(options);
      };

      this.renderPieChart = function (chart) {
        const chartOptions = {};
        if (chart.options.colors) {
          chartOptions.colors = chart.options.colors;
        }
        const options = merge(merge(defaultOptions, chartOptions), chart.options.library || {});
        let nestedData = chart.data;
        if ((chart.options.library && chart.options.library.template).match("DonutFanChart")) {
          const temp = [];
          $.each(nestedData, function () {
            temp.push({
              name: this[0],
              y: this[1],
              dataLabels: {
                rotation: 0
              }
            });
          });
          nestedData = temp;
        }
        // const i = 0;
        // for (const item in chart.data) {
        //   nestedData.concat({ name: item[0], y: item[1], index: i++ });
        // }
        options.chart.renderTo = chart.element.id;
        options.series = [{
          type: "pie",
          name: chart.options.label || "Value",
          data: nestedData
        }];

        if ((chart.options.library && chart.options.library.template).match("DonutFanChart")) {
          let allY, segmentStartAngle, segmentEndAngle, segmentMiddleAngle;
          const beforeSpacer1 = true;

          $.each(options.series, function (i, p) {
            segmentStartAngle = 0;
            segmentEndAngle = 0;
            segmentMiddleAngle = 0;
            allY = 0;

            $.each(p.data, function (i2, p2) {
              allY += p2.y;
            });

            const yToDegreeRatio = 360 / allY;

            $.each(p.data, function (i2, p2) {
              const segmentDegrees = p2.y * yToDegreeRatio;
              segmentEndAngle = segmentStartAngle + segmentDegrees;
              segmentMiddleAngle = segmentEndAngle - segmentDegrees / 2;

              // if (p2.name === "SPACER - 1") {
              //   beforeSpacer1 = false;
              // }
              // we're just going to have them outside always
              if (beforeSpacer1 || Math.abs(segmentStartAngle - segmentEndAngle) < 15 || p2.name.length > 35) {
                p2.dataLabels.distance = 16;
              } else if (segmentMiddleAngle >= 180) {
                p2.dataLabels.rotation = 90 + segmentMiddleAngle + 5 - 30;
              } else {
                p2.dataLabels.rotation = -90 + segmentMiddleAngle - 5 - 30;
              }

              segmentStartAngle = segmentEndAngle;
            });
          });
        }

        options.chart = options.chart || {};
        options.chart.events = {
          load: function () {
            adjustPieChartCenterText(this);
          }
        };

        new Highcharts.Chart(options);
      };

      this.renderColumnChart = function (chart, chartType) {
        chartType = chartType || "column";
        const series = chart.data;
        const options = jsOptions(series, chart.options), rows = [];
        let i, j, s, d;
        options.chart.type = chartType;
        options.chart.renderTo = chart.element.id;
        options.plotOptions.column.maxPointWidth = 70;

        for (i = 0; i < series.length; i++) {
          s = series[i];

          for (j = 0; j < s.data.length; j++) {
            d = s.data[j];
            if (!rows[d[0]]) {
              rows[d[0]] = new Array(series.length);
            }
            rows[d[0]][i] = d[1];
          }
        }

        const categories = [];
        for (i in rows) {
          if (rows.hasOwnProperty(i)) {
            categories.push(i);
          }
        }

        if (!options.xAxis.categories) {
          options.xAxis.categories = categories;
        } else {
          delete options.xAxis.categories;
        }

        const newSeries = [];
        for (i = 0; i < series.length; i++) {
          d = [];
          for (j = 0; j < categories.length; j++) {
            if (options.xAxis.categories) {
              d.push(rows[categories[j]][i] || 0);
            } else {
              d.push([new Date(categories[j]).getTime(), rows[categories[j]][i] || 0]);
            }
          }

          newSeries.push({
            name: series[i].name,
            data: d
          });
        }
        options.series = newSeries;

        new Highcharts.Chart(options);
      };

      const self = this;

      this.renderBarChart = function (chart) {
        self.renderColumnChart(chart, "bar");
      };

      this.renderAreaChart = function (chart) {
        self.renderLineChart(chart, "areaspline");
      };

      this.renderTreeMap = function (chart) {
        const points = [];
        recursiveIterateNestedObject(chart.data, points);

        const chartType = "treemap";

        const { point_specific_data } = chart.options;
        const options = jsOptions({}, chart.options);

        const checkImagesAreVisible = function () {
          const { data } = this.series[0];
          // let redraw = false;
          if (point_specific_data && point_specific_data.default_color) {
            data.forEach(function (point) {
              if (!point.color.pattern) { return; }

              if (point.node.values.height < 10 || point.node.values.width < 10) {
                // redraw = true;
                point.color = point_specific_data.default_color;
              }
            });

            // if (!redraw) { return; }
            // return;

            // this.series[0].update({ data: data});
          }
        };

        options.chart.type = chartType;
        options.chart.renderTo = chart.element.id;
        options.chart.events = { load: checkImagesAreVisible, redraw: checkImagesAreVisible };
        options.exporting.buttons = null;

        if (point_specific_data) {
          points.forEach(function (point) {
            const image = point_specific_data[point.name];
            if (image) {
              point.color = {
                pattern: {
                  image,
                  aspectRatio: 1,
                },
              };
              point.dataLabels = {
                enabled: false
              };
            } else {
              point.color = point_specific_data.default_color;
            }
          });
        }

        // options for ExcelNestedTreemapChart - Top 10 Users
        if (point_specific_data && chart.options.library.chart.name === "Top10UsersTreemap") {
          points.forEach(function (point) {
            point.color = point_specific_data[point.name];
            if (point_specific_data[point.name]) {
              point.dataLabels = {
                // color: "#fff"
              };
            }
          });
          options.tooltip = {
            animation: true,
            backgroundColor: "transparent",
            borderWidth: 0,
            valueSuffix: " million m³/year",
            formatter: function() {
              return `
                <div style="box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);">
                  <div style="background-color: white; padding: 10px; border-top: 8px solid ${this.color}">
                  <b>${this.key}</b></br>
                  </div>
                  <div style="background-color: white; padding: 0px 10px 10px 10px; font-size: 14px;">
                    <div style="color: ${this.color}; font-weight: bold">
                      ${numeral(this.point.value).format("0,0")}${this.series.tooltipOptions.valueSuffix}</b>
                    </div>
                    ${this.point.node.level === 1 ? "<div style='font-size: 12px;'>(Click to see water users.)</div>": ""}
                  </div>
                </div>
              `;
            },
            hideDelay: 100,
            shadow: false,
            shape: "square",
            style: { color: "black", padding: 0, width: "225px" },
            useHTML: true,
          };
        }

        // options for US state forecast treemap
        if (chart.options.library.chart.name === "USTreemap") {
          options.tooltip = {
            animation: true,
            backgroundColor: "transparent",
            borderWidth: 0,
            valuePrefix: "$",
            valueSuffix: "m",
            formatter: function() {
              return `
                <div style="box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);">
                  <div style="background-color: white; padding: 10px; border-top: 8px solid ${this.color}">
                  <b>${this.key}</b></br>
                  </div>
                  <div style="background-color: white; padding: 0px 10px 10px 10px; font-size: 14px;">
                    <div style="color: ${this.color}; font-weight: bold">
                      ${this.series.tooltipOptions.valuePrefix}${numeral(this.point.value).format("0,0")}${this.series.tooltipOptions.valueSuffix}</b>
                    </div>
                    <div style="font-size: 12px;">Capex ${chart.options.library.tooltip.yearForTooltip}</div>
                  </div>
                </div>
              `;
            },
            hideDelay: 100,
            shadow: false,
            shape: "square",
            style: { color: "black", padding: 0, width: "225px" },
            useHTML: true,
          };

          options.series = [{
            type: chartType,
            cursor: "auto",
            colors: chart.options.colors,
            colorByPoint: true,
            layoutStartingDirection: "horizontal",
            dataLabels: {
              enabled: true,
              formatter: function() {
                const abbreviateStateName = key => {
                  if(key === "Massachusetts") {
                    return "Mass.";
                  }
                  if (key === "District of Columbia") {
                    return "DC";
                  }
                  if (key === "North Carolina") {
                    return "N. Carolina";
                  }
                  return key;
                };
                return `
                  <div>
                    ${abbreviateStateName(this.key)}<br />
                    $${numeral(this.point.value).format("0,0")}m
                  </div>
                `;
              },
            },
            data: points
          }];
        } else {
          options.series = [{
            type: chartType,
            allowDrillToNode: true,
            animationLimit: 1000,
            levelIsConstant: false,
            levels: [{
              level: 1,
              dataLabels: {
                enabled: true
              },
              borderWidth: 3
            }],
            dataLabels: {
              enabled: false
            },
            data: points
          }];
        }
        new Highcharts.Chart(options);
      };
    };
    adapters.push(HighchartsAdapter);
  }
  if (!GoogleChartsAdapter && google && google.setOnLoadCallback) {
    GoogleChartsAdapter = new function () {
      this.name = "google";

      const loaded = {};
      const callbacks = [];

      const runCallbacks = function () {
        let cb, call;
        for (let i = 0; i < callbacks.length; i++) {
          cb = callbacks[i];
          call = google.visualization && ((cb.pack === "corechart" && google.visualization.LineChart) || (cb.pack === "timeline" && google.visualization.Timeline));
          if (call) {
            cb.callback();
            callbacks.splice(i, 1);
            i--;
          }
        }
      };

      const waitForLoaded = function (pack, callback) {
        if (!callback) {
          callback = pack;
          pack = "corechart";
        }

        callbacks.push({pack: pack, callback: callback});

        if (loaded[pack]) {
          runCallbacks();
        } else {
          loaded[pack] = true;

          // https://groups.google.com/forum/#!topic/google-visualization-api/fMKJcyA2yyI
          const loadOptions = {
            packages: [pack],
            callback: runCallbacks
          };
          if (config.language) {
            loadOptions.language = config.language;
          }
          google.load("visualization", "1", loadOptions);
        }
      };

      // Set chart options
      const defaultOptions = {
        chartArea: {},
        fontName: "'Lucida Grande', 'Lucida Sans Unicode', Verdana, Arial, Helvetica, sans-serif",
        pointSize: 6,
        legend: {
          textStyle: {
            fontSize: 12,
            color: "#444"
          },
          alignment: "center",
          position: "right"
        },
        curveType: "function",
        hAxis: {
          textStyle: {
            color: "#666",
            fontSize: 12
          },
          titleTextStyle: {},
          gridlines: {
            color: "transparent"
          },
          baselineColor: "#ccc",
          viewWindow: {}
        },
        vAxis: {
          textStyle: {
            color: "#666",
            fontSize: 12
          },
          titleTextStyle: {},
          baselineColor: "#ccc",
          viewWindow: {}
        },
        tooltip: {
          textStyle: {
            color: "#666",
            fontSize: 12
          }
        }
      };

      const hideLegend = function (options) {
        options.legend.position = "none";
        options.exporting.buttons.customButton.display = "none";
      };

      const setMin = function (options, min) {
        options.vAxis.viewWindow.min = min;
      };

      const setMax = function (options, max) {
        options.vAxis.viewWindow.max = max;
      };

      const setBarMin = function (options, min) {
        options.hAxis.viewWindow.min = min;
      };

      const setBarMax = function (options, max) {
        options.hAxis.viewWindow.max = max;
      };

      const setStacked = function (options, stacked) {
        options.isStacked = !!stacked;
      };

      const setXtitle = function (options, title) {
        options.hAxis.title = title;
        options.hAxis.titleTextStyle.italic = false;
      };

      const setYtitle = function (options, title) {
        options.vAxis.title = title;
        options.vAxis.titleTextStyle.italic = false;
      };

      const jsOptions = jsOptionsFunc(defaultOptions, hideLegend, setMin, setMax, setStacked, setXtitle, setYtitle);

      // cant use object as key
      const createDataTable = function (series, columnType) {
        const rows = [];
        let i, j, s, d, key;
        for (i = 0; i < series.length; i++) {
          s = series[i];

          for (j = 0; j < s.data.length; j++) {
            d = s.data[j];
            key = (columnType === "datetime") ? d[0].getTime() : d[0];
            if (!rows[key]) {
              rows[key] = new Array(series.length);
            }
            rows[key][i] = toFloat(d[1]);
          }
        }

        const rows2 = [];
        let day = true;
        let value;
        for (i in rows) {
          if (rows.hasOwnProperty(i)) {
            if (columnType === "datetime") {
              value = new Date(toFloat(i));
              day = day && isDay(value);
            } else if (columnType === "number") {
              value = toFloat(i);
            } else {
              value = i;
            }
            rows2.push([value].concat(rows[i]));
          }
        }
        if (columnType === "datetime") {
          rows2.sort(sortByTime);
        }

        // create datatable
        const data = new google.visualization.DataTable();
        columnType = columnType === "datetime" && day ? "date" : columnType;
        data.addColumn(columnType, "");
        for (i = 0; i < series.length; i++) {
          data.addColumn("number", series[i].name);
        }
        data.addRows(rows2);

        return data;
      };

      const resize = function (callback) {
        if (attachEvent) {
          attachEvent("onresize", callback);
        } else if (addEventListener) {
          addEventListener("resize", callback, true);
        }
        callback();
      };

      this.renderLineChart = function (chart) {
        waitForLoaded(function () {
          const options = jsOptions(chart.data, chart.options);
          const data = createDataTable(chart.data, chart.options.discrete ? "string" : "datetime");
          chart.chart = new google.visualization.LineChart(chart.element);
          resize(function () {
            chart.chart.draw(data, options);
          });
        });
      };

      this.renderPieChart = function (chart) {
        waitForLoaded(function () {
          const chartOptions = {
            chartArea: {
              top: "10%",
              height: "80%"
            }
          };
          if (chart.options.colors) {
            chartOptions.colors = chart.options.colors;
          }
          const options = merge(merge(defaultOptions, chartOptions), chart.options.library || {});

          const data = new google.visualization.DataTable();
          data.addColumn("string", "");
          data.addColumn("number", "Value");
          data.addRows(chart.data);

          chart.chart = new google.visualization.PieChart(chart.element);
          resize(function () {
            chart.chart.draw(data, options);
          });
        });
      };

      this.renderColumnChart = function (chart) {
        waitForLoaded(function () {
          const options = jsOptions(chart.data, chart.options);
          const data = createDataTable(chart.data, "string");
          chart.chart = new google.visualization.ColumnChart(chart.element);
          resize(function () {
            chart.chart.draw(data, options);
          });
        });
      };

      this.renderBarChart = function (chart) {
        waitForLoaded(function () {
          const chartOptions = {
            hAxis: {
              gridlines: {
                color: "#ccc"
              }
            }
          };
          const options = jsOptionsFunc(defaultOptions, hideLegend, setBarMin, setBarMax, setStacked, setXtitle, setYtitle)(chart.data, chart.options, chartOptions);
          const data = createDataTable(chart.data, "string");
          chart.chart = new google.visualization.BarChart(chart.element);
          resize(function () {
            chart.chart.draw(data, options);
          });
        });
      };

      this.renderAreaChart = function (chart) {
        waitForLoaded(function () {
          const chartOptions = {
            isStacked: true,
            pointSize: 0,
            areaOpacity: 0.5
          };
          const options = jsOptions(chart.data, chart.options, chartOptions);
          const data = createDataTable(chart.data, chart.options.discrete ? "string" : "datetime");
          chart.chart = new google.visualization.AreaChart(chart.element);
          resize(function () {
            chart.chart.draw(data, options);
          });
        });
      };

      this.renderGeoChart = function (chart) {
        waitForLoaded(function () {
          const chartOptions = {
            legend: "none",
            colorAxis: {
              colors: chart.options.colors || ["#f6c7b6", "#ce502d"]
            }
          };
          const options = merge(merge(defaultOptions, chartOptions), chart.options.library || {});

          const data = new google.visualization.DataTable();
          data.addColumn("string", "");
          data.addColumn("number", chart.options.label || "Value");
          data.addRows(chart.data);

          chart.chart = new google.visualization.GeoChart(chart.element);
          resize(function () {
            chart.chart.draw(data, options);
          });
        });
      };

      this.renderScatterChart = function (chart) {
        waitForLoaded(function () {
          const chartOptions = {};
          const options = jsOptions(chart.data, chart.options, chartOptions);
          const data = createDataTable(chart.data, "number");

          chart.chart = new google.visualization.ScatterChart(chart.element);
          resize(function () {
            chart.chart.draw(data, options);
          });
        });
      };

      this.renderTimeline = function (chart) {
        waitForLoaded("timeline", function () {
          const chartOptions = {
            legend: "none"
          };

          if (chart.options.colors) {
            chartOptions.colors = chart.options.colors;
          }
          const options = merge(merge(defaultOptions, chartOptions), chart.options.library || {});

          const data = new google.visualization.DataTable();
          data.addColumn({type: "string", id: "Name"});
          data.addColumn({type: "date", id: "Start"});
          data.addColumn({type: "date", id: "End"});
          data.addRows(chart.data);

          chart.element.style.lineHeight = "normal";
          chart.chart = new google.visualization.Timeline(chart.element);

          resize(function () {
            chart.chart.draw(data, options);
          });
        });
      };
    };

    adapters.push(GoogleChartsAdapter);
  }
  if (!ChartjsAdapter && "Chart" in window) {
    ChartjsAdapter = new function () {
      this.name = "chartjs";

      const baseOptions = {
        maintainAspectRatio: false,
        animation: false
      };

      const defaultOptions = {
        scales: {
          yAxes: [
            {
              ticks: {
                maxTicksLimit: 4
              },
              scaleLabel: {
                fontSize: 16,
                // fontStyle: "bold",
                fontColor: "#333"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false
              },
              scaleLabel: {
                fontSize: 16,
                // fontStyle: "bold",
                fontColor: "#333"
              },
              time: {},
              ticks: {}
            }
          ]
        },
        legend: {}
      };

      // http://there4.io/2012/05/02/google-chart-color-list/
      const defaultColors = [
        "#3366CC", "#DC3912", "#FF9900", "#109618", "#990099", "#3B3EAC", "#0099C6",
        "#DD4477", "#66AA00", "#B82E2E", "#316395", "#994499", "#22AA99", "#AAAA11",
        "#6633CC", "#E67300", "#8B0707", "#329262", "#5574A6", "#3B3EAC"
      ];

      const hideLegend = function (options) {
        options.legend.display = false;
        options.exporting.buttons.customButton.display = false;
      };

      const setMin = function (options, min) {
        if (min !== null) {
          options.scales.yAxes[0].ticks.min = min;
        }
      };

      const setMax = function (options, max) {
        options.scales.yAxes[0].ticks.max = max;
      };

      const setBarMin = function (options, min) {
        if (min !== null) {
          options.scales.xAxes[0].ticks.min = min;
        }
      };

      const setBarMax = function (options, max) {
        options.scales.xAxes[0].ticks.max = max;
      };

      const setStacked = function (options, stacked) {
        options.scales.xAxes[0].stacked = !!stacked;
        options.scales.yAxes[0].stacked = !!stacked;
      };

      const setXtitle = function (options, title) {
        options.scales.xAxes[0].scaleLabel.display = true;
        options.scales.xAxes[0].scaleLabel.labelString = title;
      };

      const setYtitle = function (options, title) {
        options.scales.yAxes[0].scaleLabel.display = true;
        options.scales.yAxes[0].scaleLabel.labelString = title;
      };

      const drawChart = function(chart, type, data, options) {
        chart.element.innerHTML = "<canvas></canvas>";
        const ctx = chart.element.getElementsByTagName("CANVAS")[0];

        chart.chart = new Chart(ctx, {
          type: type,
          data: data,
          options: options
        });
      };

      // http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
      const addOpacity = function(hex, opacity) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? "rgba(" + parseInt(result[1], 16) + ", " + parseInt(result[2], 16) + ", " + parseInt(result[3], 16) + ", " + opacity + ")" : hex;
      };

      const setLabelSize = function (chart, data, options) {
        let maxLabelSize = Math.ceil(chart.element.offsetWidth / 4.0 / data.labels.length);
        if (maxLabelSize > 25) {
          maxLabelSize = 25;
        }
        options.scales.xAxes[0].ticks.callback = function (value) {
          value = toStr(value);
          if (value.length > maxLabelSize) {
            return value.substring(0, maxLabelSize - 2) + "...";
          } else {
            return value;
          }
        };
      };

      const jsOptions = jsOptionsFunc(merge(baseOptions, defaultOptions), hideLegend, setMin, setMax, setStacked, setXtitle, setYtitle);

      const createDataTable = function (chart, options, chartType) {
        const datasets = [];
        const labels = [];

        const colors = chart.options.colors || defaultColors;

        let day = true;
        let week = true;
        let dayOfWeek;
        let month = true;
        let year = true;
        let hour = true;
        let minute = true;
        const detectType = (chartType === "line" || chartType === "area") && !chart.options.discrete;

        const series = chart.data;

        const sortedLabels = [];

        const rows = [];
        let i, j, s, d, key;
        for (i = 0; i < series.length; i++) {
          s = series[i];

          for (j = 0; j < s.data.length; j++) {
            d = s.data[j];
            key = detectType ? d[0].getTime() : d[0];
            if (!rows[key]) {
              rows[key] = new Array(series.length);
            }
            rows[key][i] = toFloat(d[1]);
            if (sortedLabels.indexOf(key) === -1) {
              sortedLabels.push(key);
            }
          }
        }

        if (detectType) {
          sortedLabels.sort(sortByNumber);
        }

        const rows2 = [];
        for (j = 0; j < series.length; j++) {
          rows2.push([]);
        }

        let value;
        for (let k = 0; k < sortedLabels.length; k++) {
          i = sortedLabels[k];
          if (detectType) {
            value = new Date(toFloat(i));
            // TODO make this efficient
            day = day && isDay(value);
            if (!dayOfWeek) {
              dayOfWeek = value.getDay();
            }
            week = week && isWeek(value, dayOfWeek);
            month = month && isMonth(value);
            year = year && isYear(value);
            hour = hour && isHour(value);
            minute = minute && isMinute(value);
          } else {
            value = i;
          }
          labels.push(value);
          for (j = 0; j < series.length; j++) {
            rows2[j].push(rows[i][j]);
          }
        }

        for (i = 0; i < series.length; i++) {
          s = series[i];

          const backgroundColor = chartType !== "line" ? addOpacity(colors[i], 0.5) : colors[i];

          const dataset = {
            label: s.name,
            data: rows2[i],
            fill: chartType === "area",
            borderColor: colors[i],
            backgroundColor: backgroundColor,
            pointBackgroundColor: colors[i],
            borderWidth: 2
          };

          datasets.push(merge(dataset, s.library || {}));
        }

        if (detectType && labels.length > 0) {
          let minTime = labels[0].getTime();
          let maxTime = labels[0].getTime();
          for (i = 1; i < labels.length; i++) {
            value = labels[i].getTime();
            if (value < minTime) {
              minTime = value;
            }
            if (value > maxTime) {
              maxTime = value;
            }
          }

          const timeDiff = (maxTime - minTime) / (86400 * 1000.0);

          if (!options.scales.xAxes[0].time.unit) {
            let step;
            if (year || timeDiff > 365 * 10) {
              options.scales.xAxes[0].time.unit = "year";
              step = 365;
            } else if (month || timeDiff > 30 * 10) {
              options.scales.xAxes[0].time.unit = "month";
              step = 30;
            } else if (day || timeDiff > 10) {
              options.scales.xAxes[0].time.unit = "day";
              step = 1;
            } else if (hour) {
              options.scales.xAxes[0].time.unit = "hour";
              step = 1 / 24.0;
            } else if (minute) {
              options.scales.xAxes[0].time.displayFormats = {minute: "h:mm a"};
              options.scales.xAxes[0].time.unit = "minute";
              step = 1 / 24.0 / 60.0;
            }


            if (step && timeDiff > 0) {
              let unitStepSize = Math.ceil(timeDiff / step / (chart.element.offsetWidth / 100.0));
              if (week && step === 1) {
                unitStepSize = Math.ceil(unitStepSize / 7.0) * 7;
              }
              options.scales.xAxes[0].time.unitStepSize = unitStepSize;
            }
          }

          if (!options.scales.xAxes[0].time.tooltipFormat) {
            if (day) {
              options.scales.xAxes[0].time.tooltipFormat = "ll";
            } else if (hour) {
              options.scales.xAxes[0].time.tooltipFormat = "MMM D, h a";
            } else if (minute) {
              options.scales.xAxes[0].time.tooltipFormat = "h:mm a";
            }
          }
        }

        const data = {
          labels: labels,
          datasets: datasets
        };

        return data;
      };

      this.renderLineChart = function (chart, chartType) {
        const areaOptions = {};
        if (chartType === "area") {
          // TODO fix area stacked
          // areaOptions.stacked = true;
        }
        // fix for https://github.com/chartjs/Chart.js/issues/2441
        if (!chart.options.max && allZeros(chart.data)) {
          chart.options.max = 1;
        }

        const options = jsOptions(chart.data, merge(areaOptions, chart.options));

        const data = createDataTable(chart, options, chartType || "line");

        options.scales.xAxes[0].type = chart.options.discrete ? "category" : "time";

        drawChart(chart, "line", data, options);
      };

      this.renderPieChart = function (chart) {
        const options = merge(baseOptions, chart.options.library || {});

        const labels = [];
        const values = [];
        for (let i = 0; i < chart.data.length; i++) {
          const point = chart.data[i];
          labels.push(point[0]);
          values.push(point[1]);
        }

        const data = {
          labels: labels,
          datasets: [
            {
              data: values,
              backgroundColor: chart.options.colors || defaultColors
            }
          ]
        };

        drawChart(chart, "pie", data, options);
      };

      this.renderColumnChart = function (chart, chartType) {
        let options;
        if (chartType === "bar") {
          options = jsOptionsFunc(merge(baseOptions, defaultOptions), hideLegend, setBarMin, setBarMax, setStacked, setXtitle, setYtitle)(chart.data, chart.options);
        } else {
          options = jsOptions(chart.data, chart.options);
        }
        const data = createDataTable(chart, options, "column");
        setLabelSize(chart, data, options);
        drawChart(chart, (chartType === "bar" ? "horizontalBar" : "bar"), data, options);
      };

      const self = this;

      this.renderAreaChart = function (chart) {
        self.renderLineChart(chart, "area");
      };

      this.renderBarChart = function (chart) {
        self.renderColumnChart(chart, "bar");
      };

      this.renderScatterChart = function (chart) {
        const options = jsOptions(chart.data, chart.options);

        const colors = chart.options.colors || defaultColors;

        const datasets = [];
        const series = chart.data;
        for (let i = 0; i < series.length; i++) {
          const s = series[i];
          const d = [];
          for (let j = 0; j < s.data.length; j++) {
            d.push({
              x: toFloat(s.data[j][0]),
              y: toFloat(s.data[j][1])
            });
          }

          datasets.push({
            label: s.name,
            showLine: false,
            data: d,
            borderColor: colors[i],
            backgroundColor: colors[i],
            pointBackgroundColor: colors[i]
          });
        }

        const data = {datasets: datasets};

        options.scales.xAxes[0].type = "linear";
        options.scales.xAxes[0].position = "bottom";

        drawChart(chart, "line", data, options);
      };
    };

    adapters.unshift(ChartjsAdapter);
  }
}

// TODO remove chartType if cross-browser way
// to get the name of the chart class
function renderChart(chartType, chart) {
  let i, adapter, fnName, adapterName;
  fnName = "render" + chartType;
  adapterName = chart.options.adapter;

  loadAdapters();

  for (i = 0; i < adapters.length; i++) {
    adapter = adapters[i];
    if ((!adapterName || adapterName === adapter.name) && isFunction(adapter[fnName])) {
      return adapter[fnName](chart);
    }
  }
  throw new Error("No adapter found");
}

// process data

const toFormattedKey = function (key, keyType) {
  if (keyType === "number") {
    key = toFloat(key);
  } else if (keyType === "datetime") {
    key = toDate(key);
  } else {
    key = toStr(key);
  }
  return key;
};

const formatSeriesData = function (data, keyType) {
  const r = [];
  let key, j;
  for (j = 0; j < data.length; j++) {
    key = toFormattedKey(data[j][0], keyType);
    r.push([key, toFloat(data[j][1])]);
  }
  if (keyType === "datetime") {
    r.sort(sortByTime);
  }
  return r;
};

function processSeries(series, opts, keyType) {
  // see if one series or multiple
  if (!isArray(series) || typeof series[0] !== "object" || isArray(series[0])) {
    series = [{name: opts.label || "Value", data: series}];
    opts.hideLegend = true;
  } else {
    opts.hideLegend = false;
  }
  if ((opts.discrete === null || opts.discrete === undefined)) {
    opts.discrete = detectDiscrete(series);
  }
  if (opts.discrete) {
    keyType = "string";
  }

  // right format
  for (let i = 0; i < series.length; i++) {
    series[i].data = formatSeriesData(toArr(series[i].data), keyType);
  }

  return series;
}

function processSimple(data) {
  const perfectData = toArr(data);
  for (let i = 0; i < perfectData.length; i++) {
    perfectData[i] = [toStr(perfectData[i][0]), toFloat(perfectData[i][1])];
  }
  return perfectData;
}

function processTime(data) {
  for (let i = 0; i < data.length; i++) {
    data[i][1] = toDate(data[i][1]);
    data[i][2] = toDate(data[i][2]);
  }
  return data;
}

function processLineData(chart) {
  chart.data = processSeries(chart.data, chart.options, "datetime");
  renderChart("LineChart", chart);
}

function processColumnData(chart) {
  chart.data = processSeries(chart.data, chart.options, "string");
  renderChart("ColumnChart", chart);
}

function processPieData(chart) {
  chart.data = processSimple(chart.data);
  renderChart("PieChart", chart);
}

function processBarData(chart) {
  chart.data = processSeries(chart.data, chart.options, "string");
  renderChart("BarChart", chart);
}

function processAreaData(chart) {
  chart.data = processSeries(chart.data, chart.options, "datetime");
  renderChart("AreaChart", chart);
}

function processGeoData(chart) {
  chart.data = processSimple(chart.data);
  renderChart("GeoChart", chart);
}

function processScatterData(chart) {
  chart.data = processSeries(chart.data, chart.options, "number");
  renderChart("ScatterChart", chart);
}

function processTimelineData(chart) {
  chart.data = processTime(chart.data);
  renderChart("Timeline", chart);
}

function processTreeMapData(chart) {
  // Do not post process Tree map Data. Expect it to be sent as it should be used.
  renderChart("TreeMap", chart);
}

function setElement(chart, element, dataSource, opts, callback) {
  let elementId;
  if (typeof element === "string") {
    elementId = element;
    element = document.getElementById(element);
    if (!element) {
      throw new Error("No element with id " + elementId);
    }
  }
  chart.element = element;
  chart.options = opts || {};
  chart.dataSource = dataSource;
  chart.getElement = function () {
    return element;
  };
  chart.getData = function () {
    return chart.data;
  };
  chart.getOptions = function () {
    return opts || {};
  };
  chart.getChartObject = function () {
    return chart.chart;
  };
  Chartkick.charts[element.id] = chart;
  fetchDataSource(chart, callback);
}

// define classes

Chartkick = {
  LineChart: function (element, dataSource, opts) {
    setElement(this, element, dataSource, opts, processLineData);
  },
  PieChart: function (element, dataSource, opts) {
    setElement(this, element, dataSource, opts, processPieData);
  },
  ColumnChart: function (element, dataSource, opts) {
    setElement(this, element, dataSource, opts, processColumnData);
  },
  BarChart: function (element, dataSource, opts) {
    setElement(this, element, dataSource, opts, processBarData);
  },
  AreaChart: function (element, dataSource, opts) {
    setElement(this, element, dataSource, opts, processAreaData);
  },
  GeoChart: function (element, dataSource, opts) {
    setElement(this, element, dataSource, opts, processGeoData);
  },
  ScatterChart: function (element, dataSource, opts) {
    setElement(this, element, dataSource, opts, processScatterData);
  },
  Timeline: function (element, dataSource, opts) {
    setElement(this, element, dataSource, opts, processTimelineData);
  },
  TreeMap: function (element, dataSource, opts) {
    setElement(this, element, dataSource, opts, processTreeMapData);
  },
  charts: {}
};

export default Chartkick;
